import React from 'react';
import styled from 'styled-components';
import MsxIcons from '../../features/msx-icons';
import Select from 'react-select';
import { PRIMARY_COLOR } from '../../color-constants';

const QuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 1px;
  font-size: 16px;
  margin-right: 10px;
  border: 1px solid #ccc;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  border-color: ${PRIMARY_COLOR};
  border-color: var(--se-secondary, ${PRIMARY_COLOR});
  background-color: white;
  box-sizing: border-box;

  input {
    width: 40px;
    height: 20px;
    border: none;
    text-align: center;
  }

  @media (max-width: 800px) {
    display: none;
  }
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18.5px;
  width: 18.5px;
  box-sizing: border-box;
  color: white;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  cursor: pointer;
  user-select: none;
`;

const IncreaseButton = styled(Button)`
  border-top-right-radius: 3px;
  margin-bottom: 1px;
`;

const DecreaseButton = styled(Button)`
  border-bottom-right-radius: 3px;
`;

const ButtonsML = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileWrapper = styled.div`
  display: none;
  @media (max-width: 800px) {
    display: flex;
  }
`;

class SoftwareLicenceQuantityEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        tempQuantity: props.quantity,
    };
  }

  saveQuantity = (quantity) => {
    const newQuantity = quantity;
    if (newQuantity !== this.props.quantity) {
      if (newQuantity === 0 || newQuantity == null || isNaN(newQuantity)) {
        this.props.removeSoftwareLicence(this.props.licence, () => { this.setState({ tempQuantity: this.props.quantity }); });
      } else {
        this.props.setSoftwareLicenceQuantity(this.props.licence, newQuantity);
      }
    }
  };

  handleQuantityChange = (event) => {
    this.setState({tempQuantity: parseInt(event.target.value)});
  }

  handleBlur = (event) => {
    this.saveQuantity(this.state.tempQuantity);
  }

  handleKeyPress = (event) => {
    const forbiddenCharacters = ['e', 'E', '.', ',', '+', '-'];
    if (forbiddenCharacters.includes(event.key)) {
        event.preventDefault();
    }
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        this.saveQuantity(this.state.tempQuantity);
    }
  }

  moreQuantity = () => {
    this.setState({tempQuantity: this.state.tempQuantity + 1});
  }

  lessQuantity = () => {
    const oldQuantity = this.state.tempQuantity;
    let newTempQuantity = oldQuantity - 1;
    if (newTempQuantity < 0) {
      newTempQuantity = 0;
    }
    this.setState({ tempQuantity: newTempQuantity }, () => {
      if (newTempQuantity === 0) {
        this.props.removeSoftwareLicence(this.props.licence, () => { this.setState({ tempQuantity: oldQuantity }); });
      }
    });
  };

  renderProtocols = () => {
    return (this.state.moduleSelected?.slaveProtocols || []).map((protocol, i) => {
      return (
        { value: protocol.name, label: protocol.name}
      );
    });
  }

  getMobilePossibleQuantities = () => {
    const values = [];
    for (let i = 1; i <= 100; i++) {
      values.push({ value: i, label: i});
    }
    return values;
  }

  render() {
    return (
      <>
        <QuantityWrapper
          onBlur={this.handleBlur}
          tabIndex={-1}
        >
          <input
            type="number"
            value={this.state.tempQuantity}
            onChange={this.handleQuantityChange}
            onKeyPress={this.handleKeyPress}
            onKeyDown={this.handleKeyDown}
          />
          <ButtonsML>
              <IncreaseButton onClick={this.moreQuantity}><MsxIcons size="nano" name="up-arrow" /></IncreaseButton>
              <DecreaseButton onClick={this.lessQuantity}><MsxIcons size="nano" name="down-arrow" /></DecreaseButton>
          </ButtonsML>
        </QuantityWrapper>
        <MobileWrapper>
          <Select
            isDisabled={this.props.disabled}
            value={{ value: this.state.tempQuantity, label: this.state.tempQuantity}}
            onChange={(e) => {
              let newQuantity = this.state.tempQuantity;
              try { newQuantity = parseInt(e.value) } catch {};
              this.setState({tempQuantity: newQuantity});
              this.saveQuantity(newQuantity);
            }}
            styles={{control: (provided, state) => {
              return { ...provided, marginRight: 10, height: 42, cursor: 'pointer' };
            }}}
            options={this.getMobilePossibleQuantities()}
            isSearchable={false}
          >
          </Select>
        </MobileWrapper>

      </>
    );
  }
}

export default SoftwareLicenceQuantityEditor;
